import { ProgressBarFillProps } from './progress-bar.type';
import { Tooltip } from '../../';

export const ProgressBarFill = (props: ProgressBarFillProps) => {
  const { progress = 0, label, color, total } = props;

  return (
    <div
      className={`flex h-full border-white ${progress < total && 'border-r-2'} ${color}`}
      style={{ width: `${(progress / total) * 100}%` }}
    >
      {label && (
        <Tooltip
          title={label}
          containerClassName="flex-1"
          placement="bottom"
          offsetOptions={10}
          arrowPointAtCenter
          autoPlacementOptions={{ autoAlignment: true, allowedPlacements: ['bottom', 'bottom-end', 'bottom-start'] }}
        >
          <div className="size-full"></div>
        </Tooltip>
      )}
    </div>
  );
};
